import React from 'react';
import PropTypes from 'prop-types';
import { flowRight as compose } from 'lodash';
import { injectIntl } from 'react-intl';

import AdminUserManagement from '../../../components/SiteAdmin/AdminUserManagement';
import Loader from '../../../components/Common/Loader/Loader';

import adminUserQuery from './adminUserQuery.graphql';
import adminRolesQuery from './adminRolesQuery.graphql';
import { withQuery } from '../../../hoc/withGraphql';


class AdminUser extends React.Component {

	static propTypes = {
		data: PropTypes.shape({
			loading: PropTypes.bool,
			getAllAdminRoles: PropTypes.array,
		})
	};

	static defaultProps = {
		data: {
			loading: true
		},
		adminRoles: {
			getAllAdminRoles: []
		}
	};

	render() {
		const { formatMessage } = this.props.intl;
		const { data: { loading, getAllAdminUsers, refetch } } = this.props;
		const { adminRoles: { getAllAdminRoles } } = this.props;

		return (
			<Loader type={"page"} show={loading}>
				{!loading && <AdminUserManagement data={getAllAdminUsers} loading={loading} roles={getAllAdminRoles} refetch={refetch} />}
			</Loader>
		)
	}
}

export default compose(
	injectIntl,
	withQuery(adminUserQuery, {
		options: (props) => ({
			variables: {
				currentPage: 1
			},
			fetchPolicy: 'network-only',
			ssr: false
		})
	}),
	withQuery(adminRolesQuery, {
		name: 'adminRoles',
		options: {
			fetchPolicy: 'network-only',
			ssr: false
		}
	})
)(AdminUser);